if (!customElements.get("cart-progress-step-gift")) {
  customElements.define(
    "cart-progress-step-gift",
    class CartProgressStepGift extends HTMLElement {
      cartTotalPrice = 0;

      constructor() {
        super();
        this.themeCurrency = themeVendor.themeCurrency;

        this.jsonData = null;
        try {
          this.jsonData = JSON.parse(this.querySelector('[data-cart-step-json]')?.innerHTML.replaceAll('\n', '').replace('},]', '}]'));
        } catch (error) {
          console.error(error);
        }

        if (!this.jsonData) return;

        this.rate = window.Shopify.currency.rate;
        for (const step of this.jsonData.steps) {
          step.minimum_price = step.minimum_price * this.rate;
        }
        this.progressHeight = 10;
        this.findElements();
        this.init();
      }

      findElements() {
        this.progress = this.querySelector("[data-step-progress]");
        this.progressAchieve = this.querySelector("[data-step-progress-achieve]");
        this.stepItems = this.querySelectorAll("[data-step-item]");
        this.messageElement1 = this.closest('[data-drawer]').querySelector("[data-step-message-1]");
        this.messageElement2 = this.closest('[data-drawer]').querySelector("[data-step-message-2]");
      }

      init() {
        this.listen();
      }

      listen() {
        document.addEventListener(
          "theme:cart:change",
          function (event) {
            this.cart = event.detail.cart;
            this.cartTotalPrice = this.getCartPriceNoGift(event.detail.cart);
            this.render();
          }.bind(this)
        );
        document.addEventListener(
          "theme:cart:update",
          function (event) {
            this.cart = event.detail.cart;
            this.cartTotalPrice = this.getCartPriceNoGift(event.detail.cart);
            this.render();
          }.bind(this)
        );
      }

      render() {
        const progressSteps = this.jsonData.steps;
        // 当前购物车符合条件的 Progress step（无库存赠品档视为不存在）
        let currentProgressStepIndex = -1;
        let currentProgressStep = undefined;
        for (let i = 0; i < progressSteps.length; i++) {
          const progressStep = progressSteps[i];
          if (progressStep.available === false) continue;
          if (progressStep.minimum_price <= this.cartTotalPrice && (currentProgressStep == undefined || currentProgressStep.minimum_price < progressStep.minimum_price)) {
            currentProgressStep = progressStep;
            currentProgressStepIndex = i;
          } else {
            break;
          }
        }
        // 下一个有库存的步骤
        let nextStep = null;
        let nextStepIndex = -1;
        for (let i = currentProgressStepIndex + 1; i < progressSteps.length; i++) {
          if (progressSteps[i].available === false) continue;
          nextStep = progressSteps[i];
          nextStepIndex = i;
          break;
        }

        this.updateGiftStepVisibility();
        this.updateMessage(currentProgressStep, nextStep, currentProgressStepIndex);
        this.updateProgress(currentProgressStep, nextStep, currentProgressStepIndex, nextStepIndex);
        this.updateStepItems(currentProgressStep, currentProgressStepIndex);

        for (const element of this.querySelectorAll('[data-money]')) {
          const money = Number(element.getAttribute('data-money')) * this.rate;
          if (!isNaN(money)) {
            let moneyFormat = this.formatMoney(money);
            element.innerHTML = moneyFormat;
          }
        }
      }

      // 更新提示语句
      updateMessage(currentStep, nextStep, currentStepIndex) {
        if (!this.messageElement1 || !this.messageElement2) {
          this.findElements();
        }
        // console.log('currentStepIndex:', currentStepIndex, 'currentStep: ', currentStep, 'nextStep: ', nextStep);

        if (!currentStep && !nextStep) {
          if (this.messageElement1 != null) this.messageElement1.innerHTML = '';
          if (this.messageElement2 != null) this.messageElement2.innerHTML = '';
        } else if (!currentStep) {
          // 什么都没满足
          const spendMoreMoney = nextStep.minimum_price - this.cartTotalPrice;
          if (this.messageElement1 != null) this.messageElement1.innerHTML = nextStep.before_message.replace("||amount||", this.formatMoney(spendMoreMoney));
          if (this.messageElement2 != null) this.messageElement2.innerHTML = '';
        } else if (!nextStep) {
          // 全都满足
          const spendMoreMoney = 0;
          if (this.messageElement1 != null) this.messageElement1.innerHTML = currentStep.after_message.replace("||amount||", this.formatMoney(spendMoreMoney));
          if (this.messageElement2 != null) this.messageElement2.innerHTML = '';
        }
        else {
          // 部分满足
          const spendMoreMoney = nextStep ? (nextStep.minimum_price - this.cartTotalPrice) : 0;
          if (this.messageElement1 != null) this.messageElement1.innerHTML = currentStep.after_message.replace("||amount||", this.formatMoney(spendMoreMoney));
          if (this.messageElement2 != null) this.messageElement2.innerHTML = nextStep.before_message.replace("||amount||", this.formatMoney(spendMoreMoney));
        }
      }

      /**
       * 更新进度条
       * 金额比例：按完整档位序列中 currentStep → nextStep 插值（含隐藏档）
       * 像素位置：在当前档图标右缘与下一档图标左缘之间插值（图标宽度随视口变化）
       */
      updateProgress(currentStep, nextStep, currentStepIndex, nextStepIndex) {
        const containerRect = this.progress.parentElement.getBoundingClientRect();
        const maxWidth = this.progress.getBoundingClientRect().width;
        if (maxWidth <= 0) return;

        const visibleEntries = this.getVisibleStepEntries();
        if (visibleEntries.length === 0) return;

        let progressPx = 0;
        if (!currentStep && !nextStep) {
          progressPx = 0;
        } else if (!currentStep) {
          const endEntry = this.findFirstVisibleEntryAtOrAfter(visibleEntries, nextStepIndex);
          const endLeft = this.getStepItemIconEdgeX(endEntry.stepItem, 'left', containerRect);
          const offsetPriceRate = this.cartTotalPrice / nextStep.minimum_price;
          progressPx = endLeft * offsetPriceRate;
        } else if (!nextStep) {
          progressPx = maxWidth;
        } else {
          const startEntry = this.findLastVisibleEntryAtOrBefore(visibleEntries, currentStepIndex);
          const endEntry = this.findFirstVisibleEntryAtOrAfter(visibleEntries, nextStepIndex);
          const startRight = this.getStepItemIconEdgeX(startEntry.stepItem, 'right', containerRect);
          const endLeft = this.getStepItemIconEdgeX(endEntry.stepItem, 'left', containerRect);
          const offsetPriceRate = (this.cartTotalPrice - currentStep.minimum_price)
            / (nextStep.minimum_price - currentStep.minimum_price);
          progressPx = startRight + (endLeft - startRight) * offsetPriceRate;
        }

        if (this.progress != null && this.progressAchieve != null) {
          this.progressAchieve.style.width = (progressPx * 100 / maxWidth) + "%";
        }
      }

      /**
       * 档位图标（.cart-progress-step-gift__item-icon）左/右边缘相对于进度条容器的 X 坐标
       */
      getStepItemIconEdgeX(stepItem, edge, containerRect) {
        const icon = stepItem.querySelector('.cart-progress-step-gift__item-icon')
          || stepItem.querySelector('.cart-progress-step-gift__item-icon-wrapper');
        const rect = icon.getBoundingClientRect();
        return edge === 'right'
          ? rect.right - containerRect.left
          : rect.left - containerRect.left;
      }

      /** 最后一个 originalIndex <= stepIndex 的可见档位 */
      findLastVisibleEntryAtOrBefore(visibleEntries, stepIndex) {
        let result = visibleEntries[0];
        for (const entry of visibleEntries) {
          if (entry.originalIndex <= stepIndex) result = entry;
        }
        return result;
      }

      /** 第一个 originalIndex >= stepIndex 的可见档位 */
      findFirstVisibleEntryAtOrAfter(visibleEntries, stepIndex) {
        for (const entry of visibleEntries) {
          if (entry.originalIndex >= stepIndex) return entry;
        }
        return visibleEntries[visibleEntries.length - 1];
      }

      /**
       * 获取界面上展示中的档位（免邮 + 未隐藏的赠品档）
       * @returns {Array<{ stepItem: Element, progressStep: object, originalIndex: number }>}
       */
      getVisibleStepEntries() {
        const entries = [];
        const progressSteps = this.jsonData?.steps || [];
        for (let i = 0; i < this.stepItems.length; i++) {
          const stepItem = this.stepItems[i];
          if (stepItem.classList.contains('hide')) continue;
          if (stepItem.classList.contains('cart-progress-step-gift__item--unavailable')) continue;
          if (!progressSteps[i] || progressSteps[i].available === false) continue;
          entries.push({
            stepItem,
            progressStep: progressSteps[i],
            originalIndex: i,
          });
        }
        return entries;
      }

      // 更新步骤
      updateStepItems(currentStep, currentStepIndex) {
        // 激活指定步骤
        if (currentStepIndex < 0 || currentStep == undefined) {
          for (const stepItem of this.stepItems) {
            stepItem.classList.remove('active');
          }
        } else {
          for (let i = 0; i < this.stepItems.length; i++) {
            const stepItem = this.stepItems[i];
            i <= currentStepIndex
              ? stepItem.classList.add('active')
              : stepItem.classList.remove('active');
          }
        }
      }

      /**
       * 更新赠品档位 DOM 的显示/隐藏（与 cart-progress-step-gift.liquid 逻辑一致）
       * 赠品池全无库存的档位视为不存在；
       * 有库存总档位 > 3 时：优先展示大于当前档位且最接近的 3 档，不足则展示最高的 3 档
       */
      updateGiftStepVisibility() {
        const giftSteps = window.cartGiftSettings?.steps || [];
        const giftStepOffset = this.stepItems.length - giftSteps.length;
        const availableRanks = [];
        let availableCount = 0;
        for (let i = 0; i < giftSteps.length; i++) {
          if (this.isGiftStepAvailable(giftSteps[i])) {
            availableCount++;
            availableRanks[i] = availableCount;
          } else {
            availableRanks[i] = 0;
          }
        }
        const { currentGiftStepNumber } = this.getGiftStepInfo(giftSteps);

        for (let i = 0; i < giftSteps.length; i++) {
          const stepItem = this.stepItems[giftStepOffset + i];
          if (!stepItem) continue;
          const isAvailable = availableRanks[i] > 0;
          stepItem.classList.toggle('cart-progress-step-gift__item--unavailable', !isAvailable);
          if (!isAvailable) {
            stepItem.classList.add('hide');
            continue;
          }
          const hideStep = this.shouldHideGiftStep(availableRanks[i], currentGiftStepNumber, availableCount);
          stepItem.classList.toggle('hide', hideStep);
        }
      }

      /**
       * 赠品档是否有至少一个可售变体
       */
      isGiftStepAvailable(step) {
        return (step?.gift_products ?? []).some(
          (product) => product.available && product.first_available_variant?.id != null
        );
      }

      /**
       * 计算当前满足的赠品档位（仅有库存的赠品档，不含免邮）
       * @param {Array} giftSteps - window.cartGiftSettings.steps
       * @returns {{ currentGiftStepNumber: number, countGiftStepNumber: number }}
       *   currentGiftStepNumber: 有库存赠品档中的序号，0 表示未满足任何赠品档位
       *   countGiftStepNumber: 有库存赠品档位总数
       */
      getGiftStepInfo(giftSteps) {
        let currentGiftStepNumber = 0;
        let highestMetMinimum = 0;
        let availableCount = 0;
        for (let i = 0; i < giftSteps.length; i++) {
          if (!this.isGiftStepAvailable(giftSteps[i])) continue;
          availableCount++;
          const minimum = giftSteps[i].minimum_price_not_rate != null
            ? giftSteps[i].minimum_price_not_rate * this.rate
            : giftSteps[i].minimum_price;
          if (this.cartTotalPrice >= minimum && minimum > highestMetMinimum) {
            highestMetMinimum = minimum;
            currentGiftStepNumber = availableCount;
          }
        }
        return { currentGiftStepNumber, countGiftStepNumber: availableCount };
      }

      /**
       * 判断指定赠品档位是否应隐藏
       * @param {number} tierNumber - 有库存赠品档位序号（从 1 起）
       * @param {number} currentGiftStepNumber - 当前满足的有库存赠品档位，0 表示未满足
       * @param {number} countGiftStepNumber - 有库存赠品档位总数
       * @returns {boolean} true 表示隐藏该档位
       */
      shouldHideGiftStep(tierNumber, currentGiftStepNumber, countGiftStepNumber) {
        if (countGiftStepNumber <= 3) return false;
        const tiersAbove = countGiftStepNumber - currentGiftStepNumber;
        if (tiersAbove >= 3) {
          const showMaxTier = currentGiftStepNumber + 3;
          return !(tierNumber > currentGiftStepNumber && tierNumber <= showMaxTier);
        }
        const showMinTier = countGiftStepNumber - 2;
        return tierNumber < showMinTier;
      }

      /**
       * 计算排除了 Gift 后的购物车总价
       */
      getCartPriceNoGift(cart) {
        if (!cart || cart?.items?.length == 0) return 0;
        // 赠品产品id列表
        const giftProductIdList = window.cartGiftSettings.all_gift_product_ids;
        /** 除开赠品后的购物车总价（无小数位形式, 含汇率；含订单级折扣） */
        let cartPriceNoGift = cart.total_price;

        // 计算除开赠品后的购物车总价
        for (let index = 0; index < cart.items.length; index++) {
          const cartItem = cart.items[index];
          if (giftProductIdList.includes(cartItem.product_id)) {
            cartPriceNoGift -= cartItem.final_line_price;
          }
        }
        return cartPriceNoGift;
      }

      formatMoney(integerPrice) {
        return themeVendor.themeCurrency.formatMoney(integerPrice, theme.moneyFormat)?.replace('.00', '');
      }
    }
  );
}
